<template>
  <component
    :is="to ? 'router-link' : 'a'"
    :to="to"
    class="LinkButton"
  >
    <CourtFull
      class="LinkButton__court"
      expand
    />
    <TextEpsilon
      tag="div"
      class="LinkButton__text"
    >
      <slot/>
    </TextEpsilon>
  </component>
</template>

<script>
  import CourtFull from './CourtFull';
  import TextEpsilon from './TextEpsilon';

  export default {
    components: {
      CourtFull,
      TextEpsilon,
    },
    props: {
      to: {
        type: null,
        default: null,
      },
    },
  };
</script>

<style lang="scss">
  .LinkButton__court {
    $spacing: spacing(cta);
    $size: calc(100% - #{$spacing * 2});

    position: absolute;
    top: $spacing;
    left: $spacing;
    width: $size;
    height: $size;
  }

  .LinkButton {
    position: relative;
    display: block;
    padding: spacing(cta);

    &:before,
    &:after {
      content: '';
      position: absolute;
      color: currentColor;
      left: 5px;
      width: calc(100% - 12px);
      height: 2px;
      transform: scaleX(0);
      transition-property: transform;
      transition-timing-function: timing-function(accelerate);
      transition-duration: duration(fast);
    }

    &:after {
      bottom: 5px;
      transform-origin: left;
      border-bottom: 2px solid;
    }

    &:before {
      top: 5px;
      transform-origin: right;
      border-top: 2px solid;
    }

    &:hover,
    &:focus {
      &:before,
      &:after {
        transform: scaleX(1);
        transition-timing-function: timing-function(decelerate);
      }
    }
  }

  .LinkButton__text {
    position: relative;
    text-transform: uppercase;
    padding: spacing(center-mark) spacing(center-mark) * 2;
  }
</style>
